export const AFFILIATE_MAPPINGS_REQUEST = 'AFFILIATE_MAPPINGS_REQUEST';
export const AFFILIATE_MAPPINGS_SUCCESS = 'AFFILIATE_MAPPINGS_SUCCESS';
export const AFFILIATE_MAPPINGS_FAILURE = 'AFFILIATE_MAPPINGS_FAILURE';

export const ADDRESS_SETTINGS_REQUEST = 'ADDRESS_SETTINGS_REQUEST';
export const ADDRESS_SETTINGS_FAILURE = 'ADDRESS_SETTINGS_FAILURE';
export const ADDRESS_SETTINGS_SUCCESS = 'ADDRESS_SETTINGS_SUCCESS';

export const APP_GIVE_CREDIT_CHECK_ACCESS = 'APP_GIVE_CREDIT_CHECK_ACCESS';

export const APP_CONFIG_REQUEST = 'APP_CONFIG_REQUEST';
export const APP_CONFIG_SUCCESS = 'APP_CONFIG_SUCCESS';
export const APP_CONFIG_FAILURE = 'APP_CONFIG_FAILURE';

export const BANKS_REQUEST = 'BANKS_REQUEST';
export const BANKS_FAILURE = 'BANKS_FAILURE';
export const BANKS_SUCCESS = 'BANKS_SUCCESS';

export const BANK_CASE_STATES_REQUEST = 'BANK_CASE_STATES_REQUEST';
export const BANK_CASE_STATES_FAILURE = 'BANK_CASE_STATES_FAILURE';
export const BANK_CASE_STATES_SUCCESS = 'BANK_CASE_STATES_SUCCESS';

export const BOB_FORMS_REQUEST = 'BOB_FORMS_REQUEST';
export const BOB_FORMS_FAILURE = 'BOB_FORMS_FAILURE';
export const BOB_FORMS_SUCCESS = 'BOB_FORMS_SUCCESS';

export const BOOK_QUERY_SUCCESS = 'BOOK_QUERY_SUCCESS';

export const CANCELLATION_REASONS_REQUEST = 'CANCELLATION_REASONS_REQUEST';
export const CANCELLATION_REASONS_SUCCESS = 'CANCELLATION_REASONS_SUCCESS';
export const CANCELLATION_REASONS_FAILURE = 'CANCELLATION_REASONS_FAILURE';

export const CURRENCY_SETTINGS_REQUEST = 'CURRENCY_SETTINGS_REQUEST';
export const CURRENCY_SETTINGS_SUCCESS = 'CURRENCY_SETTINGS_SUCCESS';
export const CURRENCY_SETTINGS_FAILURE = 'CURRENCY_SETTINGS_FAILURE';

export const CUSTOM_OPTIONS_REQUEST = 'CUSTOM_OPTIONS_REQUEST';
export const CUSTOM_OPTIONS_SUCCESS = 'CUSTOM_OPTIONS_SUCCESS';
export const CUSTOM_OPTIONS_FAILURE = 'CUSTOM_OPTIONS_FAILURE';

export const FETCH_REQUEST = 'FETCH_REQUEST';
export const FETCH_FAILURE = 'FETCH_FAILURE';
export const FETCH_SUCCESS = 'FETCH_SUCCESS';

export const FINANCE_SOURCES_REQUEST = 'FINANCE_SOURCES_REQUEST';
export const FINANCE_SOURCES_SUCCESS = 'FINANCE_SOURCES_SUCCESS';
export const FINANCE_SOURCES_FAILURE = 'FINANCE_SOURCES_FAILURE';

export const FLASH_MESSAGE = 'FLASH_MESSAGE';
export const FLASH_MESSAGE_RESET = 'FLASH_MESSAGE_RESET';

export const GLOBAL_SETTINGS_REQUEST = 'GLOBAL_SETTINGS_REQUEST';
export const GLOBAL_SETTINGS_SUCCESS = 'GLOBAL_SETTINGS_SUCCESS';
export const GLOBAL_SETTINGS_FAILURE = 'GLOBAL_SETTINGS_FAILURE';

export const IDENTITY_PRESETS_REQUEST = 'IDENTITY_PRESETS_REQUEST';
export const IDENTITY_PRESETS_SUCCESS = 'IDENTITY_PRESETS_SUCCESS';
export const IDENTITY_PRESETS_FAILURE = 'IDENTITY_PRESETS_FAILURE';

export const PHONE_VALIDATION_PRESETS_REQUEST = 'PHONE_VALIDATION_PRESETS_REQUEST';
export const PHONE_VALIDATION_PRESETS_SUCCESS = 'PHONE_VALIDATION_PRESETS_SUCCESS';
export const PHONE_VALIDATION_PRESETS_FAILURE = 'PHONE_VALIDATION_PRESETS_FAILURE';

export const LOGIN_GIVE_HEADQUARTERS_ACCESS = 'LOGIN_GIVE_HEADQUARTERS_ACCESS';
export const LOGIN_GIVE_BRANCH_LEADER_SUPERVISOR_II_ACCESS = 'LOGIN_GIVE_BRANCH_LEADER_SUPERVISOR_II_ACCESS';
export const LOGIN_GIVE_BRANCH_LEADER_SUPERVISOR_ACCESS = 'LOGIN_GIVE_BRANCH_LEADER_SUPERVISOR_ACCESS';
export const LOGIN_GIVE_BRANCH_LEADER_ACCESS = 'LOGIN_GIVE_BRANCH_LEADER_ACCESS';
export const LOGIN_GIVE_DEVELOPER_ACCESS = 'LOGIN_GIVE_DEVELOPER_ACCESS';
export const LOGIN_GIVE_DEVELOPER_SUPERVISOR = 'LOGIN_GIVE_DEVELOPER_SUPERVISOR';
export const LOGIN_GIVE_DEVELOPER_SALES_MANAGER = 'LOGIN_GIVE_DEVELOPER_SALES_MANAGER';
export const LOGIN_GIVE_DEVELOPER_SALES_ADMIN = 'LOGIN_GIVE_DEVELOPER_SALES_ADMIN';
export const LOGIN_GIVE_DEVELOPER_STAFF = 'LOGIN_GIVE_DEVELOPER_STAFF';
export const LOGIN_GIVE_EXTERNAL_AGENT_LEADER = 'LOGIN_GIVE_EXTERNAL_AGENT_LEADER';
export const LOGIN_GIVE_EXTERNAL_AGENT = 'LOGIN_GIVE_EXTERNAL_AGENT';
export const LOGIN_GIVE_EXTERNAL_AGENCY_ADMIN = 'LOGIN_GIVE_EXTERNAL_AGENCY_ADMIN';
export const LOGIN_GIVE_DEVELOPER_SITEPLAN_ACCESS = 'LOGIN_GIVE_DEVELOPER_SITEPLAN_ACCESS';
export const LOGIN_GIVE_SUPER_ADMIN_ACCESS = 'LOGIN_GIVE_SUPER_ADMIN_ACCESS';
export const LOGIN_GIVE_ADMIN_BASIC_ACCESS = 'LOGIN_GIVE_ADMIN_BASIC_ACCESS';
export const LOGIN_GIVE_ADMIN_COMMUNITY_ACCESS = 'LOGIN_GIVE_ADMIN_COMMUNITY_ACCESS';
export const LOGIN_GIVE_ADMIN_ACCESS = 'LOGIN_GIVE_ADMIN_ACCESS';
export const LOGIN_GIVE_MAIN_HEADQUARTERS_ACCESS = 'LOGIN_GIVE_MAIN_HEADQUARTERS_ACCESS';
export const LOGIN_GIVE_EDIT_UNIT_PRICE_ACCESS = 'LOGIN_GIVE_EDIT_UNIT_PRICE_ACCESS';
export const LOGIN_GIVE_EDIT_UNIT_DETAIL_ACCESS = 'LOGIN_GIVE_EDIT_UNIT_DETAIL_ACCESS';
export const LOGIN_USER_REQUEST = 'LOGIN_USER_REQUEST';
export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS';
export const LOGIN_USER_FAILURE = 'LOGIN_USER_FAILURE';
export const LOGIN_USER_UPDATE_SUCCESS = 'LOGIN_USER_UPDATE_SUCCESS';

export const LOGIN_FROM_ADFS = 'LOGIN_FROM_ADFS';

export const LOGOUT_USER_REQUEST = 'LOGOUT_USER_REQUEST';
export const LOGOUT_USER_FAILURE = 'LOGOUT_USER_FAILURE';
export const LOGOUT_USER_SUCCESS = 'LOGOUT_USER_SUCCESS';

export const NETWORK_FAILURE = 'NETWORK_FAILURE';
export const NETWORK_OK = 'NETWORK_OK';

export const PROJECT_BUSINESS_UNITS_REQUEST = 'PROJECT_BUSINESS_UNITS_REQUEST';
export const PROJECT_BUSINESS_UNIT_SUCCESS = 'PROJECT_BUSINESS_UNITS_SUCCESS';
export const PROJECT_BUSINESS_UNIT_FAILURE = 'PROJECT_BUSINESS_UNITS_FAILURE';

export const PROJECT_MAPPINGS_REQUEST = 'PROJECT_MAPPINGS_REQUEST';
export const PROJECT_MAPPINGS_SUCCESS = 'PROJECT_MAPPINGS_SUCCESS';
export const PROJECT_MAPPINGS_FAILURE = 'PROJECT_MAPPINGS_FAILURE';

export const PROJECT_OPTIONS_REQUEST = 'PROJECT_OPTIONS_REQUEST';
export const PROJECT_OPTIONS_SUCCESS = 'PROJECT_OPTIONS_SUCCESS';
export const PROJECT_OPTIONS_FAILURE = 'PROJECT_OPTIONS_FAILURE';

export const PROJECT_SPECIFICATIONS_REQUEST = 'PROJECT_SPECIFICATIONS_REQUEST';
export const PROJECT_SPECIFICATIONS_SUCCESS = 'PROJECT_SPECIFICATIONS_SUCCESS';
export const PROJECT_SPECIFICATIONS_FAILURE = 'PROJECT_SPECIFICATIONS_FAILURE';

export const PROJECT_UNIT_LAYOUT_SPECIFICATIONS_REQUEST = 'PROJECT_UNIT_LAYOUT_SPECIFICATIONS_REQUEST';
export const PROJECT_UNIT_LAYOUT_SPECIFICATIONS_SUCCESS = 'PROJECT_UNIT_LAYOUT_SPECIFICATIONS_SUCCESS';
export const PROJECT_UNIT_LAYOUT_SPECIFICATIONS_FAILURE = 'PROJECT_UNIT_LAYOUT_SPECIFICATIONS_FAILURE';

export const PROJECT_UNIT_SPECIFICATIONS_REQUEST = 'PROJECT_UNIT_SPECIFICATIONS_REQUEST';
export const PROJECT_UNIT_SPECIFICATIONS_SUCCESS = 'PROJECT_UNIT_SPECIFICATIONS_SUCCESS';
export const PROJECT_UNIT_SPECIFICATIONS_FAILURE = 'PROJECT_UNIT_SPECIFICATIONS_FAILURE';

export const PROMPT_MESSAGE = 'PROMPT_MESSAGE';
export const PROMPT_MESSAGE_RESET = 'PROMPT_MESSAGE_RESET';

export const SALES_CHART_TYPES_REQUEST = 'SALES_CHART_TYPES_REQUEST';
export const SALES_CHART_TYPES_SUCCESS = 'SALES_CHART_TYPES_SUCCESS';
export const SALES_CHART_TYPES_FAILURE = 'SALES_CHART_TYPES_FAILURE';

export const TAGS_REQUEST = 'TAGS_REQUEST';
export const TAGS_SUCCESS = 'TAGS_SUCCESS';
export const TAGS_FAILURE = 'TAGS_FAILURE';

export const TEMPLATES_REQUEST = 'TEMPLATES_REQUEST';
export const TEMPLATES_SUCCESS = 'TEMPLATES_SUCCESS';
export const TEMPLATES_FAILURE = 'TEMPLATES_FAILURE';

export const HIMS_DISTRICTS_REQUEST = 'HIMS_DISTRICTS_REQUEST';
export const HIMS_DISTRICTS_SUCCESS = 'HIMS_DISTRICTS_SUCCESS';
export const HIMS_DISTRICTS_FAILURE = 'HIMS_DISTRICTS_FAILURE';

export const HIMS_POSTCODES_REQUEST = 'HIMS_POSTCODES_REQUEST';
export const HIMS_POSTCODES_SUCCESS = 'HIMS_POSTCODES_SUCCESS';
export const HIMS_POSTCODES_FAILURE = 'HIMS_POSTCODES_FAILURE';



// WEBPACK FOOTER //
// ./src/constants/actions.js